import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserInfo } from 'hooks/useUserInfo';
import { Box, Typography } from '@mui/material';

interface AdminRouteProps {
  children: React.ReactNode;
  fallbackPath?: string;
  showAccessDenied?: boolean;
}

const AdminRoute: React.FC<AdminRouteProps> = ({
  children,
  fallbackPath = '/',
  showAccessDenied = false
}) => {
  const { isAdmin } = useUserInfo();

  // Check if signed-in user has admin privileges (ApplicationAdministration role only, not affected by impersonation)
  if (!isAdmin) {
    if (showAccessDenied) {
      return (
        <Box 
          display="flex" 
          justifyContent="center" 
          alignItems="center" 
          minHeight="400px"
          flexDirection="column"
          gap={2}
        >
          <Typography variant="h5" color="error">
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary">
            You do not have the required privileges to access this page.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This page is only available to users with administrative privileges.
          </Typography>
        </Box>
      );
    }
    
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
